/**
 * The one favicon-service URL template. Shared by the engine's fold (exa
 * search tool responses) and the message header/submessage rows — keep it
 * here (React-free) so the streamed and rendered favicon lists can't drift.
 */
export function faviconUrlFor(url: string): string {
  return `https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${encodeURIComponent(url)}&size=16`
}
